import { render, staticRenderFns } from "./CommonTag.vue?vue&type=template&id=c1d1f0be&scoped=true"
import script from "./CommonTag.vue?vue&type=script&lang=js"
export * from "./CommonTag.vue?vue&type=script&lang=js"
import style0 from "./CommonTag.vue?vue&type=style&index=0&id=c1d1f0be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d1f0be",
  null
  
)

export default component.exports